module.exports = __webpack_public_path__ + "img/customtag.9b78c7b6.png";